import { DayTime, getDayTime } from "@/common/helpers/get-day-time";
import { getLanguageLocale } from "@/common/helpers/get-language-locale";
import { pickRandom } from "@/common/helpers/pick-random";
import { userConfigStore } from "@/store/user-config-store";
import { userStore } from "@/store/user-store";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export interface GreetingData {
  greeting: string;
  dayTime: DayTime;
  formattedDate: string;
}

export function useGreeting(): GreetingData {
  const { t } = useTranslation("home");
  const user = userStore((state) => state.user);
  const language = userConfigStore((state) => state.language);
  const [now] = useState(() => new Date());

  return useMemo(() => {
    const dayTime = getDayTime(now);
    const firstName = user?.firstName ?? "";

    const dayTimeVariants = t(`Greeting.${dayTime}`, { returnObjects: true, name: firstName }) as string[];
    const genericVariants = t("Greeting.Generic", { returnObjects: true, name: firstName }) as string[];
    const variants = [...dayTimeVariants, ...genericVariants];

    const greeting = pickRandom(variants) ?? variants[0] ?? "";

    const formattedDate = new Intl.DateTimeFormat(getLanguageLocale(language), {
      weekday: "long",
      day: "numeric",
      month: "long",
    }).format(now);

    return {
      greeting,
      dayTime,
      formattedDate,
    };
  }, [now, user?.firstName, language, t]);
}
